<app-elevation-section title="{{ls.LNG('Label.DocumentQueue')}}">
  <dx-data-grid id="gridContainer" height="200px"
                [dataSource]="documents"
                rowAlternationEnabled="true"
                keyExpr="DocumentQueueId"
                [showBorders]="true"
                (onRowClick)="onSelectionChanged($event)">
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
    <!--<dxo-paging [pageSize]="5"> </dxo-paging>
    <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [displayMode]="displayMode" [showPageSizeSelector]="showPageSizeSelector"
               [showInfo]="showInfo" [showNavigationButtons]="showNavButtons">
    </dxo-pager>-->
    <dxo-selection mode="single"></dxo-selection>
    <dxi-column dataField="InsertDate" caption="{{ls.LNG('Label.UploadDate')}}" [width]="70"></dxi-column>
    <dxi-column dataField="InsertByName" caption="{{ls.LNG('Label.UploadedBy')}}"></dxi-column>
    <dxi-column dataField="Description" caption="{{ls.LNG('Label.Description')}}"></dxi-column>
    <dxi-column dataField="DocumentTypeName" caption="{{ls.LNG('Label.Type')}}"></dxi-column>
    <dxi-column dataField="DocumentStatusName" caption="{{ls.LNG('Label.Status')}}"></dxi-column>
  </dx-data-grid>
  <div id="form-container">
    <br>
    <div class="grid-wrapper-document-2">
      <div style="grid-column: 1">
        <dx-form id="form" [colCount]="3" [formData]="selectedLine" labelMode="outside" labelLocation="top" class="FormDocQue" (onFieldDataChanged)="onFieldDataChanged($event)">
          <dxi-item [colSpan]="2" dataField="Name">
            <dxo-label text="{{ls.LNG('Label.Name')}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="Number">
            <dxo-label text="{{ls.LNG('Label.DocumentNumber')}}"></dxo-label>
          </dxi-item>
          <dxi-item [colSpan]="3" dataField="Description">
            <dxo-label text="{{ls.LNG('Label.Description')}}"></dxo-label>
          </dxi-item>
          <dxi-item [colSpan]="2" dataField="FileName">
            <dxo-label text="{{ls.LNG('Label.FileName')}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="DocumentTypeId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: documentTypes, valueExpr: 'DocumentTypeId', displayExpr: 'Name', placeholder: 'Select a value...' }">
            <dxo-label text="{{ls.LNG('Label.Type')}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="DocumentCategoryId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: documentCategories, valueExpr: 'DocumentCategoryId', displayExpr: 'Description' }">
            <dxo-label text="{{ls.LNG('Label.Category')}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="DocumentStatusId" caption="Status"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: documentStatuses, valueExpr: 'DocumentStatusId', displayExpr: 'Name' }">
            <dxo-label text="{{ls.LNG('Label.Status')}}"></dxo-label>
          </dxi-item>
        </dx-form>
      </div>

      <div style="grid-column: 2">
        <img #imglogo style="display:table-cell; height: 180px; max-width: 100px; cursor: pointer;" src="{{thumbnail}}" />
        <div [class.hidden]="unchanged" style="padding-top: 12px">
          <dx-button stylingMode="outlined"
                     text="{{ls.LNG('Label.SaveChanges')}}"
                     type="normal"
                     width="auto"
                     (onClick)="saveChanges($event)">
          </dx-button>
        </div>
      </div>
    </div>
  </div>
</app-elevation-section>
  
